import { NgModule } from '@angular/core';
import { FormatUrlPipe } from './format-url.pipe';

@NgModule({
    declarations: [FormatUrlPipe],
    exports: [FormatUrlPipe],
})
export class FormatUrlPipeModule {}
